<template>
    <v-container fluid pt-o>
        <div class="action-bar">
            <v-row>
                <v-col cols="12">
                    <v-btn color="primary" @click="saveClick">
                        {{ $t('buttons.save') }}
                        <v-icon right>fa-save</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </div>
        <v-row>
            <v-col cols="12" lg="6">
                <v-card flat outlined>
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <InputField
                                    v-model="user.first_name"
                                    :errorBorder="!userValidation.first_name"
                                    :label="'*' + $t('fields.firstName')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <InputField
                                    v-model="user.last_name"
                                    :errorBorder="!userValidation.last_name"
                                    :label="'*' + $t('fields.lastName')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <InputField
                                    v-model="user.email"
                                    :errorBorder="!userValidation.email"
                                    :label="'*' + $t('fields.email')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12" sm="12">
                                <CheckBox
                                    v-model="user.password_change"
                                    :label="$t('fields.passwordChange')"
                                ></CheckBox>
                            </v-col>
                            <template v-if="user.password_change">
                                <v-col cols="12">
                                    <InputField
                                        v-model="user.old_password"
                                        :errorBorder="!userValidation.old_password"
                                        :label="'*' + $t('fields.oldPassword')"
                                        :type="'password'"
                                    ></InputField>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <InputField
                                        v-model="user.new_password"
                                        :errorBorder="!userValidation.new_password"
                                        :label="'*' + $t('fields.newPassword')"
                                        :type="'password'"
                                    ></InputField>
                                </v-col>

                                <v-col cols="12" sm="6">
                                    <InputField
                                        v-model="user.new_password_confirmation"
                                        :errorBorder="!userValidation.new_password_confirmation"
                                        :label="'*' + $t('fields.newPasswordConfirmation')"
                                        :type="'password'"
                                    ></InputField>
                                </v-col>
                            </template>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import InputField from './trinkets/InputField';
import CheckBox from './trinkets/CheckBox';

export default {
    name: 'Profile',
    components: {CheckBox, InputField},
    data: function () {
        return {
            user: {
                first_name: '',
                last_name: '',
                email: '',
                oib: '',
                password_change: false,
                old_password: '',
                new_password: '',
                new_password_confirmation: '',
            },
            userValidation: {
                first_name: true,
                last_name: true,
                email: true,
                oib: true,
                old_password: true,
                new_password: true,
                new_password_confirmation: true,
            },
        };
    },
    methods: {
        backClick() {
            this.$router.push('/dashboard');
        },
        saveClick() {
            let success = true;

            if (this.user.first_name == '') {
                success = false;
                this.userValidation.first_name = false;
            } else {
                this.userValidation.first_name = true;
            }

            if (this.user.last_name == '') {
                success = false;
                this.userValidation.last_name = false;
            } else {
                this.userValidation.last_name = true;
            }

            if (this.user.email == '') {
                success = false;
                this.userValidation.email = false;
            } else {
                if (!this.$checkEmail(this.user.email)) {
                    success = false;
                    this.userValidation.email = false;
                } else {
                    this.userValidation.email = true;
                }
            }

            if (this.user.password_change) {
                if (this.user.old_password == '') {
                    success = false;
                    this.userValidation.old_password = false;
                } else {
                    this.userValidation.old_password = true;
                }

                if (this.user.new_password == '') {
                    success = false;
                    this.userValidation.new_password = false;
                } else {
                    let passwordValidation = '';

                    if (this.user.new_password.length < 8) {
                        success = false;
                        this.userValidation.new_password = false;
                        passwordValidation += this.$t('alerts.passwordLength') + '<br />';
                    }

                    let letters = 0;
                    let digits = 0;
                    let others = 0;
                    for (let i = 0; i < this.user.new_password.length; i++) {
                        let character = this.user.new_password[i];
                        let letter = character.toLowerCase() !== character.toUpperCase();
                        let digit = character >= '0' && character <= 9;
                        if (letter) letters++;
                        if (digit) digits++;
                        if (!letter && !digit) others++;
                    }
                    if (letters === 0) passwordValidation += this.$t('alerts.passwordLetters') + '<br />';
                    if (digits === 0) passwordValidation += this.$t('alerts.passwordDigits') + '<br />';
                    if (others === 0) passwordValidation += this.$t('alerts.passwordOthers') + '<br />';

                    if (passwordValidation !== '') {
                        this.$alert(passwordValidation);
                    } else {
                        this.userValidation.new_password = true;
                    }
                }

                if (this.user.new_password != this.user.new_password_confirmation) {
                    success = false;
                    this.userValidation.new_password_confirmation = false;
                    this.$alert(this.$t('alerts.passwordFailConfirmation'));
                } else {
                    this.userValidation.new_password_confirmation = true;
                }
            } else {
                this.userValidation.old_password = true;
                this.userValidation.new_password = true;
                this.userValidation.new_password_confirmation = true;
            }

            if (success) {
                let vm = this;
                this.$APICall('put', 'users/' + this.$myStore.state.user.id, this.user, (data, success) => {
                    if (success) {
                        vm.$notify(vm.$t('alerts.basicUpdate'));
                    } else {
                        if (vm.user.password_change) {
                            vm.$alert(vm.$t('alerts.oldPasswordFail'));
                        } else {
                            vm.$alert(vm.$t('alerts.basicError'));
                        }
                    }
                });
            }
        },
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        this.$myStore.commit('setBreadcrumbs', [{text: this.$t('modules.profile'), href: '/profile', disabled: true}]);
        let vm = this;
        this.$APICall('get', 'users/' + this.$myStore.state.user.id, {}, (data, success) => {
            if (success) {
                let userData = data;
                userData.password_change = false;
                userData.old_password = '';
                userData.new_password = '';
                userData.new_password_confirmation = '';
                vm.user = userData;
            }
        });
    },
};
</script>

<style scoped></style>
